import React from "react";
import "./CartIcon.scss";
import { ShoppingCart } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core";
import { withRouter } from "react-router";
import { useSelector } from "react-redux";

const useStyles = makeStyles({
  icon: {
    fontSize: 35,
  },
});

const CartIcon = ({ history }) => {
  const cart = useSelector((state) => state.cart.cart);
  return (
    <div onClick={() => history.push("/checkout")} className="CartIcon">
      <p>{cart.length}</p>
      <ShoppingCart className={useStyles().icon} color="#9b9b9b" />
    </div>
  );
};

export default withRouter(CartIcon);
